import { createSelector } from 'reselect';

import { getCurrency, getLanguage, getMarket } from '@travel/i18n';

import { alwaysGlobalCurrencies } from '../../constants/currency';

const getDefaultLanguageCode = createSelector(getMarket, (currentMarket) => {
  const { displayOrder } = currentMarket;
  return displayOrder?.find((lang) => lang.priority === 1)?.langCode;
});

const getDefaultCurrency = createSelector(getMarket, (currentMarket) => {
  const { supportedCurrencies } = currentMarket;
  return supportedCurrencies?.find((curr) => Boolean(curr.isDefault))?.currency;
});

export const getIsGlobalCurrency = createSelector(
  getDefaultLanguageCode,
  getDefaultCurrency,
  getCurrency,
  getLanguage,
  (defaultLanguage, defaultCurrency, currentCurrency, currentLanguage) => {
    if ((alwaysGlobalCurrencies as readonly string[]).includes(currentCurrency)) {
      return true;
    }
    return currentLanguage !== defaultLanguage || currentCurrency !== defaultCurrency;
  },
);
